import {
  PatientMedication,
  PatientMedicationControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type Params = {
  patientMedication: PatientMedication;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const usePatientMedicationUpdate = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientMedicationControllerApi(
      getConfigObject()
    ).updatePatientMedication(params.patientMedication, params.xTENANTID)
  );
